// グローバルナビゲーション
import React from "react";
import { Center, SimpleGrid, Box, Divider } from "@chakra-ui/react";
import { Link, useStaticQuery, graphql } from "gatsby";

const GlobalNav = () => {
  const data = useStaticQuery(graphql`
    query {
      category: allGoogleCategorySheet {
        totalCount
        nodes {
          group
          count
        }
      }
    }
  `);
  console.log(data);
  return (
    <>
      <Divider />
      <SimpleGrid columns={5} spacing={5}>
        {data.category.nodes.map((node, index) => {
          return (
            <Link key={index} to={`/category/${node.group}`}>
              <Center>
                <Box>{node.group}</Box>
              </Center>
            </Link>
          );
        })}
      </SimpleGrid>
      <Divider />
    </>
  );
};

export default GlobalNav;
